class WishlistDelete extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleExternalTrigger = this.handleExternalTrigger.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)

    this.listeners.add(document, 'click', this.handleExternalTrigger)
    this.listeners.add(this.els.submit.element, 'click', this.handleSubmit)
  }

  handleExternalTrigger (event) {
    const trigger = event.target.closest(
      '[data-wishlist-delete-external-el="trigger"]',
    )

    if (!trigger || !window._swat) return

    this.els.submit.element.setAttribute(
      'data-wishlist-id',
      trigger.dataset.wishlistId,
    )
  }

  handleSubmit () {
    const lid = this.els.submit.element.dataset.wishlistId

    window._swat.deleteList(lid, window.location.reload(), this.wishlistError)
  }

  wishlistError (errorMessage) {
    // eslint-disable-next-line
    console.log(`Wishlist error: ${errorMessage}`);
  }
}

if (!customElements.get('wishlist-delete')) {
  customElements.define('wishlist-delete', WishlistDelete)
}
